import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetScenarioReviewsQuery = (
  workspaceId?: string,
  scenarioId?: string
) => {
  const { prototypes } = useAvApi();

  const data = useQuery({
    enabled: !!scenarioId && !!workspaceId,
    queryKey: ['scenario-reviews', workspaceId, scenarioId],
    queryFn: async () => {
      if (!scenarioId || !workspaceId) return;
      const data =
        await prototypes.getV2ProjectsPrototypesReviewsByProjectIdAndPrototypeId(
          { projectId: workspaceId, prototypeId: scenarioId },
          { statuses: ['COMPLETED', 'CANCELED'] }
        );

      return data.data;
    },
  });

  return data;
};
